import { Navigate, useLocation, Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, requireRole }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-[60vh] flex items-center justify-center" data-testid="protected-loading">
                <div className="op-label">Caricamento…</div>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (user.status !== "active") {
        return <Navigate to="/account-pending" replace />;
    }

    if (requireRole && user.role !== requireRole) {
        // Admins can access anything
        if (user.role !== "admin") {
            return <Navigate to="/" replace />;
        }
    }

    // Quando usato come layout (senza children espliciti) renderizza le rotte figlie.
    return children ?? <Outlet />;
}
